<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-foreword element-with-heading" epub:type="foreword" id="foreword" role="doc-foreword">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-mixed">Foreword</h1>
</div>
</div>
</div>
</div>
<div class="text" id="foreword-text">
<p class="first first-in-chapter first-full-width">The Herbert family suffered decades of persecution for their Catholic faith and Jacobite sympathies. William, the 2nd Marquess of Powis (1665-1745), was not a loyal Jacobite but helped his beloved sister, Winifred Maxwell (1672-1749), escape to France in 1716. Winifred had committed treason against George 1st through rescuing her husband from the Tower of London, on the eve of his execution. Mary Herbert (1686-1775), William’s daughter, lived in Regency Paris with a widowed aunt and was one of the earliest known female entrepreneurs and a professional gambler. These three members of the Herbert family share one ambition, to have enough money, whatever ‘enough’ means for each of them.</p>
<p class="subsq">This family lived real, well-documented lives. While the most important events happened as I describe, some names, details and dates have been altered to suit my purpose as the author. Their personalities, motives, desires, and conversations are entirely fictional and bear no resemblance to how they may have actually thought, acted, or spoken.</p>
<p class="subsq"><i>Morag Edwards</i></p>
<p class="subsq"><i>October 2023</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// foreword.vue?54553a4e